<template>
  <div>
    <review stage="1" auditType="1" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "firstReview",
    components:{review},
  }
</script>